
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface CRMSearchFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const CRMSearchFilter = ({ searchTerm, onSearchChange }: CRMSearchFilterProps) => {
  return (
    <div className="relative w-full md:w-64">
      <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Rechercher..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-9"
      />
    </div>
  );
};
